import {
  useFollowParentSchedulePreview,
  type UseFollowParentSchedulePreviewResult,
} from '@/shared/hooks/useFollowParentSchedulePreview'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface UseFollowParentUnitSchedulePreviewArgs {
  /** When false (Follow Unit OFF), no partial reloads run. */
  enabled: boolean
  unitId: number | null
  parentDaySchedule: WeekdaySchedule | undefined
  /** Seeded form already has a matching server preview — skip the first reload. */
  initialUnitId?: number | null
  /**
   * Bump after exhausted preview to retry without requiring Follow OFF→ON.
   * Instruments Form / Instrument Types dialog wire this via Try again.
   */
  retryNonce?: number
}

/**
 * Live unit day-schedule preview while Follow Unit Schedule is ON on Instruments form.
 * Thin wrapper around useFollowParentSchedulePreview (JW 387 / E45-S2).
 */
export const useFollowParentUnitSchedulePreview = ({
  enabled,
  unitId,
  parentDaySchedule,
  initialUnitId = null,
  retryNonce = 0,
}: UseFollowParentUnitSchedulePreviewArgs): UseFollowParentSchedulePreviewResult =>
  useFollowParentSchedulePreview({
    enabled,
    parentId: unitId,
    parentDaySchedule,
    initialParentId: initialUnitId,
    retryNonce,
    reloadParamKey: 'unit_id',
  })
